import { routerStyxie } from '@/router/styxieBridge'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

// Geogrids is client-side routed: every action boots the shared router shell.
// The payload hydrates the common store (it picks what it needs); per-page
// params (geogridId) come from the URL via the route definitions.
Styxie.Initializers.LiveGeogrids = routerStyxie({
  actions: ['index', 'new', 'show'],
  hydrate: (props, pinia) => useGeogridsCommonStore(pinia).initialize(props)
})
